import { isMixedSchema, MixedSchema } from '@principle-theorem/editor';
import { ISoftDelete, Region, TypeGuard } from '@principle-theorem/shared';
import { isBoolean, isString } from 'lodash';

export enum PartnerCollection {
  Apps = 'apps',
  Users = 'partnerUsers',
  TestAccounts = 'testAccounts',
}

export enum PartnerStatus {
  Live = 'live',
  Test = 'test',
  Inactive = 'inactive',
}

export const PARTNER_STATUS_MAP: {
  [key in PartnerStatus]: string;
} = {
  [PartnerStatus.Live]: 'primary',
  [PartnerStatus.Test]: 'default',
  [PartnerStatus.Inactive]: 'warn',
};

export interface IPartner extends ISoftDelete {
  name: string;
  status: PartnerStatus;
  regions: Region[];
  description: MixedSchema;
  appIconUrl?: string;
}

export const isPartner = TypeGuard.interface<IPartner>({
  name: isString,
  status: TypeGuard.enumValue(PartnerStatus),
  regions: TypeGuard.arrayOf(TypeGuard.enumValue(Region)),
  description: isMixedSchema,
  appIconUrl: TypeGuard.nilOr(isString),
  deleted: isBoolean,
});
